<template>
  <DashboardWidget class="widget-line-smooth" :loading="loading" :title="title">
    <v-chart :options="chart" :autoresize="true" />
  </DashboardWidget>
</template>

<script>

import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'dashboard-widget-line-smooth',
  components: {
    DashboardWidget: () => import('../DashboardWidget'),
    'v-chart': ECharts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    dataY: {
      type: Array,
      required: true,
    },
    dataX: {
      type: Array,
      required: true,
    },
    legend: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      chart: {
        legend: {
          data: [this.legend],
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dataX,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            symbol: 'circle',
            symbolSize: 8,
            name: this.legend,
            type: 'line',
            color: '#289ad8',
            smooth: true,
            data: this.dataY,
            lineStyle: {
              color: 'rgba(40, 154, 216,.5)',
            },
          },
        ],
      },
    };
  },
};

</script>

<style lang="scss">

.widget-line-smooth {
  .echarts {
    width: 100%;
    height: 100%;
  }
}

</style>
